import React, { useContext, useEffect, useState } from "react";
import { getCdn, mapString } from "utils";
import { getCookie, setCookie } from "utils/cookie";
import { Context } from "Context";
import Button from "components/shared/Button";

const dismissedCookieName = "earlyBookingMessageClosed";
const mainClass = "syndicated-message-banner";
const supportedAffiliationType = "CASTAWAYCLUB";
const travelAgentAffiliation = "TRAVEL_AGENT";

const getTheAffiliationWithTheHighestPriority = (
	userAffiliations = [],
	affiliationsPriority = []
) => {
	let indexOfAffiliationToShow = -1;
	userAffiliations.forEach((affiliation) => {
		if (affiliation.includes(supportedAffiliationType)) {
			const indexOfAffiliationToUse = affiliationsPriority.indexOf(
				affiliation.split(":")[1]
			);
			if (indexOfAffiliationToUse !== -1) {
				if (indexOfAffiliationToShow === -1) {
					indexOfAffiliationToShow = indexOfAffiliationToUse;
				} else if (indexOfAffiliationToShow > indexOfAffiliationToUse) {
					indexOfAffiliationToShow = indexOfAffiliationToUse;
				}
			}
		}
	});
	return affiliationsPriority[indexOfAffiliationToShow] || "";
};

const MessageBanner = () => {
	const {
		headerData: { messageBanner },
		profileData: { user, travelAgent, userType },
	} = useContext(Context);
	const [bannerMessage, setBannerMessage] = useState(null);
	const [dismissed, setDismissed] = useState(null);

	const generateBanner = (banner) => {
		if (banner?.bannerMessage) {
			setBannerMessage({
				message: mapString(banner.bannerMessage, user?.firstName || ""),
				closeAriaLabel: banner?.closeAriaLabel,
			});
		}
	};

	const closeBannerHandler = () => {
		setCookie(dismissedCookieName, "true");
		setBannerMessage(null);
		setDismissed(true);
	};

	useEffect(() => {
		try {
			const dismissedCookie = getCookie(dismissedCookieName);
			dismissedCookie && setDismissed(dismissedCookie === "true");
		} catch (error) {
			console.error(error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (
			(user || userType === travelAgentAffiliation) &&
			messageBanner?.affiliationsPriority?.length &&
			messageBanner.descriptions
		) {
			if (travelAgent?.firstName || travelAgent?.travelAgency?.partnerId) {
				generateBanner(messageBanner.descriptions[travelAgentAffiliation]);
			} else if (user?.affiliations?.length) {
				const affiliationToUse = getTheAffiliationWithTheHighestPriority(
					user.affiliations,
					messageBanner.affiliationsPriority
				);
				generateBanner(messageBanner.descriptions[affiliationToUse]);
			}
		}
		if (
			(user || userType !== travelAgentAffiliation) &&
			user?.ebsMessageBanner
		) {
			const ebsMessageBannerDetails = {};
			ebsMessageBannerDetails.bannerMessage = user?.ebsMessageBanner;
			ebsMessageBannerDetails.closeAriaLabel =
				messageBanner?.affiliationsPriority?.length &&
				messageBanner?.descriptions
					? messageBanner.descriptions[messageBanner.affiliationsPriority[0]]
							?.closeAriaLabel
					: "Close Message";
			generateBanner(ebsMessageBannerDetails);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user, travelAgent, messageBanner, userType]);

	if (!messageBanner || dismissed || !bannerMessage) return null;

	return (
		<section className={mainClass}>
			<div className={`${mainClass}__content`}>
				<div
					className={`${mainClass}__message guestSensitive`}
					dangerouslySetInnerHTML={{ __html: bannerMessage.message }}
				/>
				{bannerMessage.closeAriaLabel && (
					<>
						<Button
							className={`${mainClass}__close`}
							onClick={closeBannerHandler}
							ariaLabel={bannerMessage.closeAriaLabel}
							style={{
								backgroundImage: `url(${getCdn(
									true
								)}/icons/pep/close-button.svg)`,
							}}
						/>
					</>
				)}
			</div>
		</section>
	);
};

export default MessageBanner;
